var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.379,
    height: 20.379,
    viewBox: "0 0 20.379 20.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.437,256.993a5.5,5.5,0,1,1,5.784-5.494A5.649,5.649,0,0,1,382.437,256.993Zm0-9.989a4.5,4.5,0,1,0,4.732,4.5A4.624,4.624,0,0,0,382.437,247Z",
    transform: "translate(-372.078 -246.005)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.676,266H373.851a1.541,1.541,0,0,1-1.577-1.5,5.764,5.764,0,0,1,1.288-3.3,7.436,7.436,0,0,1,3.017-2.217,16.963,16.963,0,0,1,11.37,0,7.446,7.446,0,0,1,3.017,2.217,5.764,5.764,0,0,1,1.288,3.3A1.541,1.541,0,0,1,390.676,266ZM382.263,259c-3.666,0-6.372.952-7.825,2.753a4.915,4.915,0,0,0-1.113,2.743.513.513,0,0,0,.525.5h16.825a.513.513,0,0,0,.525-.5,4.9,4.9,0,0,0-1.113-2.741C388.634,259.956,385.929,259,382.263,259Z",
    transform: "translate(-372.274 -246.018)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.98a73492e4d1e0705d226cf411a728c9.svg";
export { ForwardRef as ReactComponent };